import { Component, PropsWithChildren, ReactNode } from 'react'

interface Props {
  fallback?: ReactNode
}

interface State {
  hasError: boolean
}

/**
 * Renders `fallback` (default: nothing) instead of crashing the whole app when a
 * child throws during render. Used to isolate the dynamically-built sidebar so a
 * malformed menu can never white-screen Compass for everyone.
 */
class SafeBoundary extends Component<PropsWithChildren<Props>, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: unknown) {
    console.error('SafeBoundary caught an error:', error)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null
    }
    return this.props.children
  }
}

export default SafeBoundary
